import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-lg text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1 text-weight-bold q-mb-sm" }, " Import New Posts ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-body1" }, " You have been requested to import new posts. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_import_posts_btn = _resolveComponent("import-posts-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_ctx.request.assignee === 'client')
      ? (_openBlock(), _createBlock(_component_import_posts_btn, {
          key: 0,
          account: _ctx.account,
          label: "Import Posts",
          color: "primary",
          rounded: "",
          class: "q-mt-sm"
        }, null, 8, ["account"]))
      : _createCommentVNode("", true)
  ]))
}